/**
 * Wire contract for the admin runtime-config READ surface (AUT-120 /
 * PHASE-B-API-9):
 *
 *   - `GET /admin/config`               → `AdminConfigListDto`
 *   - `GET /admin/config/:key/history`  → `AdminConfigHistoryDto`
 *
 * Centralised in `@carcheck/shared` so the api + admin SPA import the same
 * source of truth — no api↔admin mirror drift.
 *
 * **Read-only.** The single-key WRITE already exists (`PATCH /admin/config/:key`,
 * AUT-105); these two surfaces feed the future `/admin/config` page.
 *
 * **No PII / no secrets on this surface.** All runtime-config keys are
 * business knobs (pricing %, escrow days, limits, feature flags) — secrets
 * live in env vars / `AppConfigService` (a separate module). No redaction.
 *
 * **`value` is typed `JsonValue`** — the runtime store holds arbitrary JSON
 * (number / string / boolean / array / object). The wire stays free of any
 * `@prisma/client` import; the api maps its Prisma `Json` column onto this TS
 * shape at the mapper boundary. `null` carries a distinct meaning here: the
 * key exists in the typed registry but has NO row in the DB (`present:false`)
 * — NOT a JSON `null` value.
 *
 * All `Date` fields are ISO-8601 strings (JSON has no `Date`); consumers
 * convert at the render boundary via `new Date(dto.lastChangedAt)`.
 */
/**
 * The four wire-stable value-type discriminators surfaced to the SPA so it
 * can pick an editor widget (number input / text / toggle / JSON editor)
 * without re-deriving the type from the value.
 *
 * Derived server-side via `typeof` (the typed registry has no runtime type
 * discriminator — values are stored as opaque Prisma `Json`). `object` +
 * `Array.isArray` both fold to `'json'`; everything else maps 1:1.
 */
export const ADMIN_CONFIG_VALUE_TYPES = ['number', 'string', 'boolean', 'json'];
//# sourceMappingURL=admin-config-list.js.map